import { createApp } from 'vue'
import App from './App.vue'
import router from './router/routes'
import store from './store'
import axios from "axios";

axios.defaults.baseURL = "https://projects.dotlinkertech.com/balibusinessclub/public/" 

createApp(App).use(store).use(router).mount('#app')
